import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import { Item } from "../../models/item";
import { SET_ACTIVE_MENU_PATH } from "../../store/actions/configurationActions";
import { getActiveMenuPath, getMenuCache } from "../../store/sagas/selectors";
import GaReporter from "../../utilities/gaReporter";
import { isMenuCategory } from "../../utilities/itemUtilities";

const CategoriesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 10px 15px 5px 15px;
    ${({ theme }) =>
        theme.bp.tb`
        padding: 10px 0 5px 0;
    `}
`;

const CategoryButton = styled.div`
    font-size: 14px;
    &.selected {
        border-bottom: solid 2px ${props => props.theme.sideMenu.backButton.color};
    }
    margin: 4px 9px;
    padding: 0px 0px 7px 0px;
    cursor: pointer;
    transition: 0.4s ease-in-out;
    border-bottom: solid 2px rgba(0, 0, 0, 0);
    @media (hover) {
        &:hover {
            border-bottom: solid 2px ${props => props.theme.sideMenu.backButton.color};
        }
    }
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1.2em;
                `}
`;

export const MenuCategoryTabs = () => {
    const dispatch = useDispatch();
    const menuPath = useSelector(getActiveMenuPath);
    const menus = useSelector(getMenuCache);
    const components = menuPath.reduce((result, bc, i, arr) => {
        if (isMenuCategory(bc.id)) {
            // Get all categories from the parent menu.
            const menu = menus[arr[i - 1].id];
            if (menu) {
                const selectTab = (categoryItem: Item) => {
                    const text = categoryItem.shortText || categoryItem.id;
                    GaReporter.event("product_category_select", "Configurator", text);
                    const newMenuPath = menuPath.slice(0, i);
                    newMenuPath.push({ id: categoryItem.id, text: text });
                    dispatch({ type: SET_ACTIVE_MENU_PATH, activeMenuPath: newMenuPath });
                };

                result.push(
                    <CategoriesContainer key={bc.id}>
                        {menu.items.map(item => (
                            <CategoryButton
                                key={item.id}
                                onClick={() => selectTab(item)}
                                className={bc.id === item.id ? "selected" : ""}
                            >
                                {item.shortText || item.id}
                            </CategoryButton>
                        ))}
                    </CategoriesContainer>
                );
            }
        }
        return result;
    }, [] as JSX.Element[]);

    return <>{components}</>;
};
